import type { OptionsDocument, PublicTagDetails, Tag } from 'paintscout'

export function mapPublicToTagDetails({
  options,
  tagDetails
}: {
  options: OptionsDocument
  tagDetails: PublicTagDetails[]
}): Tag[] {
  const res = tagDetails.map((publicTagDetails) => {
    // Find the tag key from options using the label or name
    const tagKey = Object.keys(options?.options?.quoteTags?.values ?? {}).find((key) => {
      const tag = options.options?.quoteTags?.values[key]
      return tag && (tag.label === publicTagDetails.label || tag.name === publicTagDetails.name)
    })

    return {
      name: tagKey || publicTagDetails.name,
      deleted: publicTagDetails.deleted ?? false,
      updated: publicTagDetails.updated ?? Date.now()
    }
  })

  return res
}
